import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/operators'
import Component from 'components/Operators'

export default createListViewContainer({ actions, selectors: selectors.operators })(Component)
